import ProductosContainer from './ProductosContainer';
export default ProductosContainer;